<section class="w-full h-full md:px-10 md:pb-24 md:pt-10 px-4 py-8">
  <div class="container mx-auto h-full w-full">
    <div class="flex flex-col items-center justify-center gap-4">
      <h2
        i18n="organizer.help|How we could help heading@@organizer.help.title"
        class="text-2xl md:text-3xl font-bold text-black"
      >
        How We Could Help?
      </h2>
    </div>
    <div class="flex flex-row flex-wrap items-stretch justify-center md:gap-4 gap-2 mt-10">
      @for (help of helps; track $index) {
        <div
          class="flex flex-col items-center text-center bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:w-[calc(33%-0.5rem)] w-full max-w-xs gap-4"
        >
          <div class="w-full max-h-56">
            <img [src]="help.image" [alt]="help.title" class="w-full h-full object-contain" />
          </div>
          <div class="flex flex-col gap-2 flex-1">
            <h3 class="text-base font-bold text-gray-900">{{ help.title }}</h3>
            <p class="text-sm text-gray-500 leading-relaxed">{{ help.description }}</p>
          </div>
        </div>
      }
    </div>
  </div>
</section>
